import React from 'react'

import { LinkButton } from 'components/Button'
import { StyledBackButtonIcon } from './BackButton.styles'
import { useBackButton } from './useBackButton'

type BackButtonProps = {
  className?: string
}

/**
 * Contextual back button for the shares related views so that
 * the user can quickly come back to the previous view they are
 * coming from.
 */
export default function BackButton({ className }: BackButtonProps) {
  const { content, link } = useBackButton()

  return (
    <LinkButton
      to={link}
      icon={StyledBackButtonIcon}
      tiny={true}
      variant="secondary-untinted"
      className={className}>
      {content}
    </LinkButton>
  )
}
